module.exports = __webpack_public_path__ + "static/media/options-grey.a59390fe.svg";